/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
/* ============================================================
   Loop preset-bundle integrity guard + free-gift auto-add (Habituel)
   Append this entire block to the END of assets/custom.js
   (replaces any earlier version of this block).

   What it does:
   1. AUTO-ADD GIFTS: when the Day|Night bundle's children (Coffee+ &
      Cocoa+) land in the cart, the gift items from the customizer list
      (currently three: Mini Electric Mixer, Sticker Pack, Travel Dose) are added
      as one-time lines carrying the same _bundleId + a _bundleGift
      marker. They are made FREE by the Shopify automatic discount
      "Day | Night Bundle — Free Gifts" (server-side, holds at
      checkout). One-time lines never recur on subscription renewals.
   2. ATOMIC BUNDLE: removing ANY line of the group (bag or gift)
      removes the entire group. Changing a bag's quantity syncs the
      other bag; gifts stay pinned at one set per order.
   3. SCOPE: only cart lines with _bundleId AND (_isPresetBundleProduct
      or _bundleGift). Loop build-your-own bundles and every other cart
      line are untouched. Never runs on Loop's own /a/loop_subscriptions
      pages.
   4. GIFT LIST SOURCE: the list is read from window.DNB_GIFT_VARIANTS,
      emitted by snippets/dnb-gift-config.liquid from the theme setting
      "Bundle free gifts" (customizer). THAT SETTING IS THE ONLY SOURCE.
      An empty list means NO gifts are added - by design (2026-09-02, per
      Kai), so gifts can be changed or switched off from the customizer
      without touching code. There is deliberately no fallback list.
      Remember: the customizer list must match the "Customer gets"
      products (and quantity) of the automatic discount
      "Day | Night Bundle - Free Gifts" in Admin -> Discounts; with the
      list empty, that discount simply has nothing to act on.
   5. CHECKOUT LOCK (2026-08-31): a click on Checkout made while the
      cart is still settling is deferred, not dropped. See the block
      comment on the lock below.
   ============================================================ */
(function () {
  /* The customizer list, or nothing. An empty/missing list is a valid
     state that means "this bundle ships without gifts" - see header note 4.
     (A hard-coded fallback used to live here; it was never read, and when
     the audit wired it in Kai chose the empty-means-off behaviour instead.) */
  function giftVariants() {
    var v = window.DNB_GIFT_VARIANTS;
    return (v && v.length) ? v : [];
  }

  var prevQty = null;        /* line key -> quantity (for qty-change direction) */
  var prevPaidCount = {};    /* bundleId -> number of paid lines last seen */
  var prevGiftCount = {};    /* bundleId -> number of gift lines last seen */
  var giftAddAttempted = {}; /* bundleId -> true (avoid retry loops if a gift is unavailable) */
  var busy = false;

  /* ============================================================
     CHECKOUT LOCK (2026-08-31)

     THE PROBLEM: a cart mutation leaves the cart briefly inconsistent.
     A bundle's gifts land 1-3s after its two paid children, and until
     they do the totals and this guard's own bookkeeping are mid-flight.
     Checking out inside that window carried the half-built cart into
     checkout: two bundles at once, with gifts billed at CATALOG price,
     because the automatic discount frees one gift set per ORDER
     (usesPerOrderLimit: 1), not one per bundle. Measured window: ~1s.

     THE APPROACH: do NOT disable the Checkout button. Dimming the most
     important button on the site for 1-3s after every add would cost
     more conversions than this bug does. Instead a click made while the
     cart is unsettled is SWALLOWED and REPLAYED the instant it settles.
     The customer sees a normal button; the click just takes a beat.
     Nothing is blocked, only deferred.

     FAILS OPEN, THREE WAYS - checkout can never be left unclickable:
       - the lock releases QUIET_MS after the LAST cart write, on a
         timer that is re-armed by each write and owned by nobody else;
       - LOCK_HARD_MS is an absolute ceiling regardless of re-arming;
       - enforce() releases it early on any pass that finds no work,
         and on its error path.
     No release depends on enforce() reaching a particular line.

     ROLLBACK: delete this block, the armLock()/releaseLock() calls in
     enforce() and in the fetch hook, and the two capture listeners.
     ============================================================ */
  var QUIET_MS = 1500;       /* release this long after the last cart write */
  var LOCK_HARD_MS = 10000;  /* absolute ceiling on a single lock */
  var locked = false;
  var lockTimer = null;
  var lockDeadline = 0;
  var queuedBtn = null;      /* the Checkout control the customer clicked while locked */
  var replaying = false;     /* true only during our own synthetic re-click */

  var CHECKOUT_SEL = '.cart__checkout:not(.no-js), button[name="checkout"], .additional-checkout-buttons button, .additional-checkout-buttons a';

  function lockStyleOnce() {
    if (document.getElementById('dnb-checkout-lock-style')) return;
    var s = document.createElement('style');
    s.id = 'dnb-checkout-lock-style';
    /* only ever applied to a button the customer has actually clicked */
    s.textContent = '.dnb-checkout-waiting{opacity:.75!important;cursor:progress!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function armLock() {
    var now = Date.now();
    if (!locked) { locked = true; lockDeadline = now + LOCK_HARD_MS; }
    if (lockTimer) clearTimeout(lockTimer);
    var wait = Math.max(0, Math.min(QUIET_MS, lockDeadline - now));
    lockTimer = setTimeout(releaseLock, wait);
  }

  function releaseLock() {
    if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
    locked = false;
    flushQueuedCheckout();
  }

  function flushQueuedCheckout() {
    if (!queuedBtn) return;
    var btn = queuedBtn;
    queuedBtn = null;
    try { btn.classList.remove('dnb-checkout-waiting'); } catch (e) {}
    /* Replay the ORIGINAL control's own click so the theme's handlers and
       the submit button's name=checkout are preserved. form.submit() would
       drop the button name and take the wrong branch. */
    replaying = true;
    try { btn.click(); } catch (e) {}
    setTimeout(function () { replaying = false; }, 0);
  }

  document.addEventListener('click', function (e) {
    if (!locked || replaying) return;
    var t = (e.target && e.target.closest) ? e.target.closest(CHECKOUT_SEL) : null;
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    if (queuedBtn) return; /* already queued; extra clicks are no-ops */
    queuedBtn = t;
    lockStyleOnce();
    try { t.classList.add('dnb-checkout-waiting'); } catch (err) {}
  }, true);

  document.addEventListener('submit', function (e) {
    if (!locked || replaying) return;
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.id === 'cartForm' || f.matches('[data-cart-form]')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  /* ========================= end checkout lock ========================= */

  function bundleIdOf(item) {
    if (!item.properties) return null;
    if (!item.properties._isPresetBundleProduct && !item.properties._bundleGift) return null;
    return item.properties._bundleId || item.properties.bundleId || null;
  }
  function isGift(item) {
    return !!(item.properties && item.properties._bundleGift);
  }

  /* ============================================================
     GIFT OPT-OUT (2026-09-03). Customer feedback: "I'd like the option to
     NOT include the extra free items". The cart attribute "Free gifts" =
     "skipped" is the single source of truth (written by the toggle in the
     bundle card, see the block after this guard). While it is set:
       - no gift set is added, and any gift lines present are removed;
       - that removal is the guard's own write, so the per-kind line counts is
         recomputed from the post-update counts and Rule 1 never reads it
         as the shopper breaking the bundle.
     When it clears, giftAddAttempted is reset so the set is added back in
     the next pass. Being a cart attribute it persists across pages and
     sessions and lands on the order as a note attribute for fulfilment.
     ============================================================ */
  var GIFT_ATTR = 'Free gifts';
  var GIFT_SKIP = 'skipped';
  var lastSkipped = null;
  function giftsSkipped(cart) {
    var a = cart && cart.attributes;
    return !!(a && String(a[GIFT_ATTR] || '').toLowerCase() === GIFT_SKIP);
  }

  function enforce() {
    if (busy) return;
    if (window.location.pathname.indexOf('/a/loop_subscriptions') !== -1) { releaseLock(); return; }
    busy = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {};
        cart.items.forEach(function (it) {
          var b = bundleIdOf(it);
          if (b) { (groups[b] = groups[b] || []).push(it); }
        });

        var skipped = giftsSkipped(cart);
        if (lastSkipped === true && !skipped) giftAddAttempted = {}; /* opted back in: allow one add pass per group */
        lastSkipped = skipped;

        /* The opt-out is "for this order". With no bundle left in the cart the
           order it applied to is gone, so clear it: the next bundle starts with
           gifts included, as every bundle does by default. One write, then the
           pass triggered by it finds nothing to do. */
        var groupCount = Object.keys(groups).length;
        if (skipped && groupCount === 0) {
          lastSkipped = false;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Free gifts': '' } })
          }).then(function () { busy = false; }, function () { busy = false; releaseLock(); });
        }

        var updates = {};
        var giftAdds = []; /* [{ bundleId: b, items: [...] }] */
        var removed = {};  /* bundleId -> true, groups being torn down this pass */

        Object.keys(groups).forEach(function (b) {
          var items = groups[b];
          var paid = items.filter(function (i) { return !isGift(i); });
          var gifts = items.filter(isGift);

          /* Rule 1: the group shrank (any member removed) -> remove the whole group.
             Counted per kind since 2026-09-03: a gift line leaving while gifts are
             skipped is this guard's own write, never the shopper breaking the bundle. */
          var shrankPaid = prevPaidCount[b] != null && paid.length < prevPaidCount[b];
          var shrankGifts = prevGiftCount[b] != null && gifts.length < prevGiftCount[b];
          var shrank = shrankPaid || (shrankGifts && !skipped);
          /* Rule 2: safety - a bundle must have both paid children. */
          var incomplete = paid.length < 2;

          if (shrank || incomplete) {
            removed[b] = true;
            items.forEach(function (i) { updates[i.key] = 0; });
            return;
          }

          /* Rule 3: paid lines keep equal quantities (follow the changed line). */
          var qtys = paid.map(function (i) { return i.quantity; });
          var allEqual = qtys.every(function (q) { return q === qtys[0]; });
          if (!allEqual) {
            var target = null;
            if (prevQty) {
              paid.forEach(function (i) {
                var old = prevQty[i.key];
                if (old != null && old !== i.quantity) target = i.quantity;
              });
            }
            if (target == null) target = Math.min.apply(null, qtys);
            paid.forEach(function (i) {
              if (i.quantity !== target) updates[i.key] = target;
            });
          }

          /* Rule 4: every gift line is quantity 1 - or gone, while gifts are skipped. */
          gifts.forEach(function (i) {
            if (skipped) updates[i.key] = 0;
            else if (i.quantity !== 1) updates[i.key] = 1;
          });
        });

        /* ============================================================
           Rule 5 (rewritten 2026-08-31): ONE GIFT SET PER CART.

           This rule used to run per bundle group, so a second bundle got
           its own second set of gift lines. But the automatic discount
           "Day | Night Bundle — Free Gifts" is configured
           usesPerOrderLimit: 1 - it frees three gift lines per ORDER, not
           per bundle. Two bundles therefore produced six gift lines of
           which only three were freed, and the customer was billed
           $15 + $6 + $15 = $36 for items the cart labelled "Free".

           The header comment on this file has always said gifts "stay
           pinned at one set per order"; the code just never enforced it
           across groups. It does now: surplus gift lines are dropped and
           one set is kept, attached to a surviving group so it is still
           removed atomically with it.

           IF YOU WANT TWO BUNDLES TO EARN TWO GIFT SETS, this is the
           rule to change - and the discount's usesPerOrderLimit must be
           lifted to match, which also needs its "customer buys" condition
           tightened first (today it targets the Coffee+/Cocoa+ PRODUCTS,
           so uncapped it would hand free gifts to anyone adding two bags
           without a bundle).
           ============================================================ */
        var giftList = giftVariants();
        if (giftList.length && !skipped) {
          var survivingGifts = [];
          var firstSurviving = null;
          var ownerWithGifts = null;

          Object.keys(groups).forEach(function (b) {
            if (removed[b]) return;
            if (!firstSurviving) firstSurviving = b;
            groups[b].forEach(function (i) {
              if (isGift(i) && updates[i.key] !== 0) survivingGifts.push(i);
            });
          });

          /* Keep the first line of each gift variant; drop any duplicate.
             Dropping them here is safe: the per-kind counts are recomputed below
             from the post-update line counts, so the donor group does not
             look like it "shrank" on the next pass. */
          var seen = {};
          var kept = 0;
          survivingGifts.forEach(function (i) {
            if (seen[i.variant_id]) {
              updates[i.key] = 0;
            } else {
              seen[i.variant_id] = true;
              kept++;
              if (!ownerWithGifts) ownerWithGifts = bundleIdOf(i);
            }
          });

          var owner = ownerWithGifts || firstSurviving;
          if (owner && kept < giftList.length && !giftAddAttempted[owner]) {
            var missing = giftList.filter(function (v) { return !seen[v]; });
            if (missing.length) {
              giftAddAttempted[owner] = true;
              giftAdds.push({
                bundleId: owner,
                items: missing.map(function (v) {
                  return {
                    id: v,
                    quantity: 1,
                    properties: { _bundleId: owner, _bundleGift: true }
                  };
                })
              });
            }
          }
        }

        /* Refresh snapshots to the state we are about to enforce. */
        prevQty = {};
        cart.items.forEach(function (it) { prevQty[it.key] = it.quantity; });
        Object.keys(updates).forEach(function (k) {
          if (updates[k] === 0) { delete prevQty[k]; } else { prevQty[k] = updates[k]; }
        });
        prevPaidCount = {};
        prevGiftCount = {};
        Object.keys(groups).forEach(function (b) {
          var remaining = groups[b].filter(function (i) { return updates[i.key] !== 0; });
          if (!remaining.length) return;
          prevPaidCount[b] = remaining.filter(function (i) { return !isGift(i); }).length;
          prevGiftCount[b] = remaining.filter(isGift).length;
        });

        var didWork = false;
        var chain = Promise.resolve();

        if (Object.keys(updates).length) {
          didWork = true;
          chain = chain.then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          });
        }

        /* BUGFIX (2026-08-31) - silent deletion of an earlier bundle.
           This used to be a single `giftsToAdd` object plus:

             Object.keys(prevGroupCount).forEach(function (b) {
               if (giftAddAttempted[b]) prevGroupCount[b] += giftsToAdd.items.length;
             });

           giftAddAttempted is never cleared, so adding a SECOND bundle's
           gifts also bumped the FIRST bundle's expected line count by 3.
           The first bundle then had 5 lines where the snapshot expected 8,
           Rule 1 read that as "the customer removed a line", and deleted
           the whole group - silently, ~1s after the second add. Customers
           buying two bundles lost one without being told.

           Now only the bundle that actually received the gifts is bumped.
           Two side fixes fall out of the same change: giftAdds is a LIST,
           so two groups needing gifts on the same pass both get them (the
           old single variable kept only the last), and the writes are
           CHAINED rather than fired in parallel - concurrent writes to the
           Shopify cart API can drop one. */
        giftAdds.forEach(function (ga) {
          didWork = true;
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: ga.items })
            }).then(function () {
              if (prevGiftCount[ga.bundleId] != null) {
                prevGiftCount[ga.bundleId] += ga.items.length;
              }
            });
          });
        });

        if (!didWork) { busy = false; releaseLock(); return; }

        return chain.then(function () {
          var ci = document.querySelector('cart-items');
          if (ci && typeof ci.getCart === 'function') ci.getCart();
          busy = false;
          /* The writes above re-armed the lock through the fetch hook; the
             next pass finds no work and releases it. The quiet timer and
             the hard ceiling both cover us if that pass never happens. */
        });
      })
      .catch(function () { busy = false; releaseLock(); });
  }

  /* Re-check after every cart mutation the storefront makes. */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    try {
      var u = String((input && input.url) || input || '');
      var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      /* Writes only. A GET whose URL merely contains one of these words must
         not arm the checkout lock (2026-09-01 audit). */
      if (m === 'POST' && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(u)) {
        armLock();
        p.then(function () { setTimeout(enforce, 120); }).catch(function () { releaseLock(); });
      }
    } catch (e) {}
    return p;
  };
  document.addEventListener('theme:cart:change', function () {
    armLock(); /* covers cart writes made with XHR rather than fetch */
    setTimeout(enforce, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();

/* ============================================================
   GIFT OPT-OUT TOGGLE + CART CHROME SYNC (2026-09-03)

   1. [data-dnb-gifts-toggle="skip"|"include"] in the bundle card
      (snippets/cart-line-items.liquid) writes the cart attribute
      "Free gifts" = "skipped" / "" via /cart/update.js. Nothing else: the
      guard above reacts to the write (its fetch hook fires enforce()) and
      removes or re-adds the gift set, then the theme re-renders the cart
      and the row reads back the new state. Delegated on document, bound
      once, so it survives every drawer re-render. The button is disabled
      while its write is in flight and for a beat after, so a double tap
      cannot flip the flag twice.
   2. "Checkout · $total": copies [data-dnb-total-money] (rendered by
      snippets/dnb-cart-totals.liquid inside the AJAX-refreshed price
      holder) into the button after every cart change.
   3. Hides the "Have a discount code?" block while an applied-code chip is
      on the page (browsers without :has support).
   ============================================================ */
(function () {
  if (window.__dnbGiftToggleBound) return;
  window.__dnbGiftToggleBound = true;
  var busy = false;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-dnb-gifts-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;
    var skip = btn.getAttribute('data-dnb-gifts-toggle') === 'skip';
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (!skip) window.__dnbGiftRestoreTs = Date.now();
    var unstick = setTimeout(function () { busy = false; }, 12000);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Free gifts': skip ? 'skipped' : '' } })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        /* The guard's pass (triggered by the write above) does the gift work and
           asks cart-items to refresh; ask once more a moment later so the row
           shows the settled state even if the guard found nothing to do. */
        setTimeout(function () {
          [].forEach.call(document.querySelectorAll('cart-items'), function (ci) {
            if (typeof ci.getCart === 'function') ci.getCart();
          });
        }, 900);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      })
      .then(function () {
        clearTimeout(unstick);
        setTimeout(function () { busy = false; }, 1200);
      });
  }, true);

  function syncChrome() {
    try {
      var src = document.querySelector('[data-dnb-total-money]');
      if (src) {
        var txt = src.textContent.trim();
        [].forEach.call(document.querySelectorAll('[data-dnb-checkout-total]'), function (t) {
          if (t.textContent.trim() !== txt) t.textContent = txt;
        });
      }
      var hasChip = !!document.querySelector('[data-dnb-disc-chip]');
      [].forEach.call(document.querySelectorAll('.dnb-disc'), function (d) { d.hidden = hasChip; });
    } catch (err) {}
  }
  document.addEventListener('theme:cart:change', function () { setTimeout(syncChrome, 0); setTimeout(syncChrome, 400); });
  document.addEventListener('theme:cart-drawer:open', function () { setTimeout(syncChrome, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncChrome); else syncChrome();
})();

/* ============================================================
   DNB Bundle ATC Normalizer v3 (2026-08-17)
   WHY: The Day|Night bundle adds 5 line items (2 paid children +
   3 free gifts), so Elevar fires 5 dl_add_to_cart per click and
   the gifts carry CATALOG prices ($15/$5/$6). Meta then receives
   5 AddToCart events worth $81 for one $55 add.
   WHAT: Chains on window.ElevarDataLayer.push (Elevar's public
   API; feeds BOTH the web pixel and the /a/elevar/browser/bulk
   server beacon). Per 800ms burst of dl_add_to_cart events:
     - gift-variant events are dropped IF paid items are in the
       same burst (standalone gift purchases pass untouched)
     - remaining events merge into ONE dl_add_to_cart
   One bundle click -> exactly 1 AddToCart at $55, both channels.
   SAFETY: no DOM reads, no network, no libraries. Fails open:
   any error = original Elevar behavior. Loop/cart untouched.
   REMOVE IF Elevar ships native bundle dedup (ticket open).
   Merging is product-agnostic (works for ANY future bundle);
   gift filtering follows window.DNB_GIFT_VARIANTS (customizer).
   ============================================================ */
(function () {
  /* Gift list AUTO-SYNCS with the customizer: window.DNB_GIFT_VARIANTS is
     emitted by snippets/dnb-gift-config.liquid from the "Bundle free gifts"
     theme setting — the same source the bundle guard uses to ADD the gifts.
     Change gifts in the customizer and this filter follows automatically.
     An empty list means no gifts are added, so there is nothing to filter
     (no fallback, by design - 2026-09-02). */
  function giftSet() {
    var list = (window.DNB_GIFT_VARIANTS && window.DNB_GIFT_VARIANTS.length)
      ? window.DNB_GIFT_VARIANTS : [];
    var m = {};
    for (var i = 0; i < list.length; i++) m[String(list[i])] = 1;
    return m;
  }
  var WINDOW_MS = 800;          /* burst window for merging paid items */
  var GIFT_SUPPRESS_MS = 10000; /* gifts arriving within 10s of a paid add = bundle gifts -> drop
                                   (Loop adds gifts 1-3s AFTER the children, in separate bursts) */
  var POLL_MS = 250;            /* installer poll while Elevar boots */
  var GIVE_UP_MS = 20000;       /* stop polling if Elevar never loads */
  var RECHECK_MS = 3000;        /* re-chain if Elevar re-inits push */

  var buf = [], timer = null, wrapped = null, upstream = null, lastPaidTs = 0;

  /* Health status — check anytime via console: __dnbATCN
     state: 'waiting'  = looking for Elevar (first 20s)
            'active'   = filtering installed and running
            'gave-up'  = Elevar not found/changed -> NO filtering,
                         stock Elevar behavior (5x events, nothing broken) */
  var S = window.__dnbATCN = { v: 1, state: 'waiting', merged: 0, dropped: 0, passthrough: 0, shapeDrift: 0 };

  function isATC(e) { return !!(e && e.event === 'dl_add_to_cart'); }
  function prods(e) {
    try { return (e.ecommerce.add && e.ecommerce.add.products) || []; }
    catch (err) { return []; }
  }
  function isGiftEvent(e) {
    var p = prods(e);
    if (!p.length) return false;
    var G = giftSet();
    for (var i = 0; i < p.length; i++) {
      if (!G[String(p[i].variant_id)]) return false;
    }
    return true;
  }
  function flush() {
    timer = null;
    var b = buf; buf = [];
    try {
      var i;
      /* SHAPE GUARD: if any event no longer matches the known Elevar
         shape (ecommerce.add.products[]), do NOT touch the burst at
         all — forward every original as-is. Protects against future
         Elevar API/schema changes. */
      for (i = 0; i < b.length; i++) {
        if (!prods(b[i]).length) {
          S.shapeDrift += b.length; S.passthrough += b.length;
          for (var s = 0; s < b.length; s++) upstream(b[s]);
          return;
        }
      }
      var paid = [], gift = [];
      for (i = 0; i < b.length; i++) (isGiftEvent(b[i]) ? gift : paid).push(b[i]);
      if (!paid.length) { /* standalone gift purchase: untouched */
        S.passthrough += gift.length;
        for (i = 0; i < gift.length; i++) upstream(gift[i]);
        return;
      }
      S.dropped += gift.length;
      if (paid.length === 1) { S.passthrough++; upstream(paid[0]); return; }
      var merged = JSON.parse(JSON.stringify(paid[0]));
      var all = [];
      for (i = 0; i < paid.length; i++) all = all.concat(prods(paid[i]));
      merged.ecommerce.add.products = all;
      S.merged++;
      upstream(merged);
    } catch (err) { /* fail open: forward originals */
      for (var k = 0; k < b.length; k++) { try { upstream(b[k]); } catch (e2) {} }
    }
  }
  function ourPush() {
    var args = arguments;
    try {
      for (var i = 0; i < args.length; i++) {
        var e = args[i];
        if (isATC(e)) {
          /* __dnbGiftRestoreTs: set by the gift opt-out toggle when a shopper adds
             the gifts back; those adds are not new add-to-carts either. */
          if (isGiftEvent(e) && ((Date.now() - lastPaidTs) < GIFT_SUPPRESS_MS || (Date.now() - (window.__dnbGiftRestoreTs || 0)) < GIFT_SUPPRESS_MS)) {
            /* gift riding along with a recent paid add = bundle gift -> drop.
               A gift added with no recent paid add (standalone purchase)
               skips this branch and passes through via the buffer below. */
            S.dropped++;
            continue;
          }
          if (!isGiftEvent(e) && prods(e).length) lastPaidTs = Date.now();
          buf.push(e);
          if (timer) clearTimeout(timer);
          timer = setTimeout(flush, WINDOW_MS);
        } else {
          upstream(e);
        }
      }
      return window.ElevarDataLayer.length;
    } catch (err) {
      return upstream.apply(null, args);
    }
  }
  function install() {
    var edl = window.ElevarDataLayer;
    /* wait until Elevar's own override is in place, then chain on top */
    if (!edl || typeof edl.push !== 'function' || edl.push === Array.prototype.push) return false;
    if (edl.push === wrapped) return true;
    var prev = edl.push;
    upstream = function () { return prev.apply(edl, arguments); };
    wrapped = ourPush;
    edl.push = ourPush;
    return true;
  }
  var started = Date.now();
  var poll = setInterval(function () {
    if (install()) {
      clearInterval(poll);
      S.state = 'active';
      setInterval(install, RECHECK_MS); /* cheap pointer check; re-chains if Elevar re-inits */
    } else if (Date.now() - started > GIVE_UP_MS) {
      clearInterval(poll);
      S.state = 'gave-up'; /* Elevar absent or API changed: stock behavior, nothing filtered, nothing broken */
    }
  }, POLL_MS);
})();

/* ============================================================
   DISCOUNT CODE FIELD  (2026-08-31)

   Controller for snippets/dnb-discount.liquid. Lives here, not in an inline
   <script> in sections/cart-drawer.liquid, for two reasons:

     1. That script was inside `{% if template.name != 'cart' %}`, so the
        /cart page never got a controller - and now that /cart renders the
        same field, it needs one.
     2. The drawer re-renders itself over AJAX. A listener bound to elements
        found at load time dies the first time the shopper changes a
        quantity. Everything below is delegated on `document` and bound
        once, so it survives any number of re-renders.

   HOW A CODE IS APPLIED

   /cart/update.js accepts a `discount` field (Cart AJAX API, 2025-05+) and
   returns the resulting cart, so the code lands on the CART and the totals
   update immediately - no redirect through /discount/CODE, no full reload.
   Verified against this store on 2026-08-31: a valid code comes back
   {applicable:true} with total_price reduced; a bogus one comes back
   {applicable:false} with the total untouched.

   That second case is why an invalid code is explicitly cleared below. The
   API stores it on the cart regardless, so leaving it there means the
   shopper carries a dead code into checkout and sees it listed there having
   done nothing.

   Sending `discount: ''` clears the code. Shopify's cart carries one code at
   a time, so removing "the" code and clearing them all are the same call -
   the × in the totals row therefore does not need to name which code it is
   removing, though it passes it anyway so this stays correct if that changes.
   ============================================================ */
(function () {
  if (window.__dnbDiscountBound) return;
  window.__dnbDiscountBound = true;

  var BUSY = false;
  var APPLY_SEQ = 0;

  function el(root, sel) { return root ? root.querySelector(sel) : null; }

  /* Nothing here builds markup any more. The applied code renders as a row in
     the cart totals (snippets/dnb-discount-total.liquid), which the theme
     re-renders for us on every cart refresh - so apply and remove only have to
     talk to the API and then ask for that refresh. The previous version painted
     a chip from the cart JSON, which meant duplicating the Liquid's
     description logic in JS and keeping the two wordings in sync by hand. */

  /* Ask the theme to re-render the cart, which is what refreshes the totals
     (including the "Discount · CODE" row). cart-items is the theme's own
     custom element; getCart() is its refresh entry point. */
  function refreshTotals() {
    [].forEach.call(document.querySelectorAll('cart-items'), function (ci) {
      if (typeof ci.getCart === 'function') ci.getCart();
    });
  }

  function say(wrap, text, ok) {
    var msg = el(wrap, '[data-dnb-disc-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('is-ok', !!ok);
    msg.classList.toggle('is-err', !ok);
    msg.hidden = false;
  }
  function clearSay(wrap) {
    var msg = el(wrap, '[data-dnb-disc-msg]');
    if (msg) { msg.hidden = true; msg.textContent = ''; }
  }

  function post(discount) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: discount })
    }).then(function (r) { return r.json(); });
  }

  function apply(wrap) {
    if (BUSY) return;
    var input = el(wrap, '[data-dnb-disc-input]');
    var btn = el(wrap, '[data-dnb-disc-apply]');
    var code = input ? (input.value || '').trim() : '';
    if (!code) { if (input) input.focus(); return; }

    BUSY = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Applying'; }
    clearSay(wrap);

    /* The code that is applied right now, if any. Shopify keeps ONE code on
       the cart, so posting a new one REPLACES it - even when the new one turns
       out not to apply. Remember the old one so a typo cannot silently strip
       a working discount (2026-09-01 audit: it did, and the totals kept
       showing the old code while checkout charged full price). */
    /* Read the applied code(s) from the cart itself rather than the totals
       row: a free-shipping or product-level code has no cart-level row to
       read from, and a multi-code cart would only show one. */
    var prev = '';
    var my = ++APPLY_SEQ;

    /* Safety valve: a hung request must not leave Apply disabled for the rest
       of the session (BUSY is shared with remove()). */
    var unstick = setTimeout(function () { BUSY = false; if (btn) { btn.disabled = false; btn.textContent = 'Apply'; } }, 15000);

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        prev = (c.discount_codes || []).filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; }).join(',');
      })
      .catch(function () {})
      .then(function () { return post(code); })
      .then(function (cart) {
        /* A newer apply() has started (the 15s valve let one through): let it
           own the outcome rather than overwrite it with this stale result. */
        if (my !== APPLY_SEQ) return;
        var match = (cart.discount_codes || []).filter(function (c) {
          return String(c.code).toLowerCase() === code.toLowerCase();
        })[0];

        if (match && match.applicable) {
          if (input) input.value = '';
          refreshTotals();
          /* Most codes show up as a "Discount · CODE" row in the totals once
             the theme re-renders. Free-shipping codes and $0 allocations do
             not (they are not cart-level applications), so give those an
             explicit confirmation instead of folding the field shut on a
             cart that looks unchanged. */
          return waitFor(function () { return !!document.querySelector('[data-dnb-disc-chip], .dnb-totals__code, .dnb-disc-total'); }, 2500)
            .then(function (seen) {
              if (seen) { collapse(wrap); }
              else { say(wrap, 'Code applied. Any discount it gives shows at checkout.', true); }
            });
        }

        /* Not applicable: put the cart back the way it was. Restoring the
           previous code (or clearing, if there was none) means the totals
           and checkout stay in agreement. Then re-render so the row and
           subtotal reflect the cart as it actually is. */
        say(wrap, prev
          ? 'That code isn’t valid for this cart. ' + prev.replace(/,/g, ', ') + ' is still applied.'
          : 'That code isn’t valid for this cart.', false);
        return post(prev).then(refreshTotals);
      })
      .catch(function () { if (my === APPLY_SEQ) { say(wrap, 'Something went wrong — try again.', false); refreshTotals(); } })
      .then(function () {
        clearTimeout(unstick);
        if (my !== APPLY_SEQ) return; /* a newer apply() owns BUSY and the button now */
        BUSY = false;
        if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
      });
  }

  /* Resolve true as soon as pred() holds, false after ms. */
  function waitFor(pred, ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function tick() {
        if (pred()) return resolve(true);
        if (Date.now() - t0 > ms) return resolve(false);
        setTimeout(tick, 120);
      })();
    });
  }

  function remove(wrap, btn) {
    if (BUSY) return;
    BUSY = true;
    clearSay(wrap);
    if (btn) btn.setAttribute('aria-busy', 'true');
    var unstick = setTimeout(function () { BUSY = false; if (btn) btn.removeAttribute('aria-busy'); }, 15000);
    post('')
      .then(function () { refreshTotals(); })
      .catch(function () {
        say(wrap, 'Could not remove that code — try again.', false);
        /* On /cart there is no discount block to write into, so the row's own
           × is the only place a failure can be shown. */
        if (btn) btn.setAttribute('title', 'Could not remove — try again');
      })
      .then(function () { clearTimeout(unstick); BUSY = false; if (btn) btn.removeAttribute('aria-busy'); });
  }

  function expand(wrap) {
    var t = el(wrap, '[data-dnb-disc-toggle]');
    var row = el(wrap, '[data-dnb-disc-row]');
    var input = el(wrap, '[data-dnb-disc-input]');
    if (t) t.setAttribute('aria-expanded', 'true');
    if (row) row.hidden = false;
    if (input) input.focus();
  }
  function collapse(wrap) {
    var t = el(wrap, '[data-dnb-disc-toggle]');
    var row = el(wrap, '[data-dnb-disc-row]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (row) row.hidden = true;
    clearSay(wrap);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var rm = t.closest('[data-dnb-disc-remove]');
    if (rm) {
      e.preventDefault();
      /* The x lives in the TOTALS row, which is outside [data-dnb-discount] -
         so closest() finds nothing and there would be no element to write an
         error into. Fall back to the discount block on the page, which is
         where the shopper is looking anyway. */
      remove(rm.closest('[data-dnb-discount]') || document.querySelector('[data-dnb-discount]'), rm);
      return;
    }

    var tog = t.closest('[data-dnb-disc-toggle]');
    if (tog) {
      e.preventDefault();
      var w = tog.closest('[data-dnb-discount]');
      if (tog.getAttribute('aria-expanded') === 'true') collapse(w); else expand(w);
      return;
    }

    var ap = t.closest('[data-dnb-disc-apply]');
    if (ap) {
      e.preventDefault();
      apply(ap.closest('[data-dnb-discount]'));
    }
  });

  /* Enter submits the code, and must NOT submit the checkout form it sits
     inside - which is what would happen by default in the drawer. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.closest ? e.target.closest('[data-dnb-disc-input]') : null;
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    apply(input.closest('[data-dnb-discount]'));
  });
})();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
